import { render, staticRenderFns } from "./BIChatsSuporte.vue?vue&type=template&id=423192c3"
import script from "./BIChatsSuporte.vue?vue&type=script&setup=true&lang=js"
export * from "./BIChatsSuporte.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BIChatsSuporte.vue?vue&type=style&index=0&id=423192c3&prod&lang=scss"
import style1 from "./BIChatsSuporte.vue?vue&type=style&index=1&id=423192c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports